import DS_Certificate from "./data_science_components/DS_Certificate";
import DS_Database_Table from "./data_science_components/DS_Database_Table";
import DS_DataFrame from "./data_science_components/DS_DataFrame";
import DS_Data_Preparation from "./data_science_components/DS_Data_Preparation";
import DS_Functions from "./data_science_components/DS_Functions";
import DS_Home from "./data_science_components/DS_Home";
import DS_Introduction from "./data_science_components/DS_Introduction";
import DS_Linear_Functions from "./data_science_components/DS_Linear_Functions";
import DS_Linear_Regression from "./data_science_components/DS_Linear_Regression";
import DS_Linear_Regression_Case from "./data_science_components/DS_Linear_Regression_Case";
import DS_Plotting_Functions from "./data_science_components/DS_Plotting_Functions";
import DS_Python from "./data_science_components/DS_Python";
import DS_Regression_Coefficients from "./data_science_components/DS_Regression_Coefficients";
import DS_Regression_Info from "./data_science_components/DS_Regression_Info";
import DS_Regression_P_Value from "./data_science_components/DS_Regression_P_Value";
import DS_Regression_R_Squared from "./data_science_components/DS_Regression_R_Squared";
import DS_Regression_Table from "./data_science_components/DS_Regression_Table";
import DS_Slope_And_Intercept from "./data_science_components/DS_Slope_And_Intercept";
import DS_What_Is_Data from "./data_science_components/DS_What_Is_Data";
import Stat_Correlation from "./data_science_components/Stat_Correlation";
import Stat_Correlation_Matrix from "./data_science_components/Stat_Correlation_Matrix";
import Stat_Correlation_Vs_Causality from "./data_science_components/Stat_Correlation_Vs_Causality";
import Stat_Introduction from "./data_science_components/Stat_Introduction";
import Stat_Percentiles from "./data_science_components/Stat_Percentiles";
import Stat_Standard_Deviation from "./data_science_components/Stat_Standard_Deviation";
import Stat_Variance from "./data_science_components/Stat_Variance";

const AllDataScienceComponents = {
  "<DS_Certificate />": DS_Certificate,
  "<DS_Database_Table />": DS_Database_Table,
  "<DS_DataFrame />": DS_DataFrame,
  "<DS_Data_Preparation />": DS_Data_Preparation,
  "<DS_Functions />": DS_Functions,
  "<DS_Home />": DS_Home,
  "<DS_Introduction />": DS_Introduction,
  "<DS_Linear_Functions />": DS_Linear_Functions,
  "<DS_Linear_Regression />": DS_Linear_Regression,
  "<DS_Linear_Regression_Case />": DS_Linear_Regression_Case,
  "<DS_Plotting_Functions />": DS_Plotting_Functions,
  "<DS_Python />": DS_Python,
  "<DS_Regression_Coefficients />": DS_Regression_Coefficients,
  "<DS_Regression_Info />": DS_Regression_Info,
  "<DS_Regression_P_Value />": DS_Regression_P_Value,
  "<DS_Regression_R_Squared />": DS_Regression_R_Squared,
  "<DS_Regression_Table />": DS_Regression_Table,
  "<DS_Slope_And_Intercept />": DS_Slope_And_Intercept,
  "<DS_What_Is_Data />": DS_What_Is_Data,
  "<Stat_Correlation />": Stat_Correlation,
  "<Stat_Correlation_Matrix />": Stat_Correlation_Matrix,
  "<Stat_Correlation_Vs_Causality />": Stat_Correlation_Vs_Causality,
  "<Stat_Introduction />": Stat_Introduction,
  "<Stat_Percentiles />": Stat_Percentiles,
  "<Stat_Standard_Deviation />": Stat_Standard_Deviation,
  "<Stat_Variance />": Stat_Variance,
};

export default AllDataScienceComponents;
